const getFileName = (url) => {
  if (!url) return null;

  return url.substring(url.lastIndexOf('/') + 1);
};

export default getFileName;
